import { FC, ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
	children: ReactNode | ReactNode[];
}

const Container: FC<Props> = ({ children }) => (
	<Wrapper className="main-container">{children}</Wrapper>
);

const Wrapper = styled.div`
	width: 1320px;
	max-width: 95%;
	margin: 0 auto;

	@media (min-width: 1600px) {
		width: 1420px;
	}

	@media (min-width: 1750px) {
		width: 1520px;
	}

	@media (min-width: 1900px) {
		width: 1650px;
	}

	@media (max-width: 535px) {
		padding: 0 10px;
		width: 100%;
		max-width: 100%;
	}
`;

export default Container;
